import React, { useState, useEffect } from 'react'

export interface Props {
  onVoucherChange: (voucher: string) => void
  resetValue: boolean
}

const Voucher: React.FunctionComponent<Props> = (props) => {
  const { onVoucherChange, resetValue } = props
  const [ voucherValue, setVoucherValue ] = useState<string>('')

  useEffect(() => {
    setVoucherValue('')
  }, [ resetValue ])

  return <div className="checkout_property__voucher">
    <form onSubmit={(evt) => {
      evt.preventDefault()
      onVoucherChange(voucherValue)
    }}>
      <input
        placeholder="Enter voucher code"
        value={voucherValue}
        onChange={(evt) => {
          setVoucherValue(evt.target.value)
        }}
      />
      <input type="submit" value="Add Voucher" />
    </form>
  </div>
}

export default Voucher

